"use client"

import { useCallback, useSyncExternalStore } from "react"
import type { AnimatedAvatarSources } from "@/components/ui/animated/avatar/avatar"
import type { Conversation } from "./model"

export type DanAIActivity = "idle" | "thinking" | "responding"
export const danAIAnimations = Object.fromEntries(["idle", "thinking", "responding"].map(mode => [mode, {
  mode, webp: `/brand/danai/danai-motion-v2/${mode}.webp?v=glow2`, apng: `/brand/danai/danai-motion-v2/${mode}.apng?v=glow2`, gif: `/brand/danai/danai-motion-v2/${mode}.gif?v=glow2`,
}])) as Record<DanAIActivity, AnimatedAvatarSources>

// All source animations loop. UI activity follows the shared conversation: a
// reply accent returns to idle after its display window, cancelling stale timers.
export function useDanAIActivity(conversation?: Conversation): DanAIActivity {
  const last = conversation?.messages.filter(message => message.visibility === "public").at(-1)
  const typing=conversation?.typing,author=last?.author,at=last?.at
  const read=useCallback(():DanAIActivity=>typing?"thinking":author==="ai"&&at!==undefined&&Date.now()<at+1920?"responding":"idle",[typing,author,at])
  const subscribe=useCallback((notify:()=>void)=>{
    if(typing||author!=="ai"||at===undefined)return()=>{}
    const remaining=Math.max(0,at+1920-Date.now())
    const timer = window.setTimeout(notify, remaining + 1)
    return () => window.clearTimeout(timer)
  },[typing,author,at])
  return useSyncExternalStore(subscribe,read,()=>"idle" as const)
}
